/**
 * https://sunlife.atlassian.net/browse/TB-7081
 * https://sunlife.atlassian.net/browse/SGR-1164
 *
 * Read the description of the PR below to get more context on this:
 * https://github.com/DailyFeats/slfus-client-onboard/pull/7040
 *
 * "Output Encoding is a security technique used to sanitize or transform data before
 * it is rendered or transmitted, ensuring it is safe for use in the application."
 */

const keys = new Set([
  "kickoffCallPeople",
  "kickoffCallSchedule",
  "kickoffCallTopics",
  "installCallSchedule",
  "installCallTopics",
  "installCallPeople",
  "enrollmentNeeds",
  "benAdminPlatformOtherName",
  "previousSlfPolicies",
  "billPayrollCyclesOther",
  "name",
  "address1",
  "address2",
  "city",
  "state",
  "zipCode",
  "firstName",
  "lastName",
  "title",
]);

export function outputEncoding(body: unknown) {
  traverse(body, outputEncoding, outputEncodingReplace);
}

export function outputDecoding<T>(body: T) {
  traverse(body, outputDecoding, outputEncodingRestore);
  return body;
}

function traverse(
  body: unknown,
  coder: (body: unknown) => void,
  replacer: (input: string) => string,
) {
  if (isRecord(body)) {
    for (const key in body) {
      const value = body[key];
      if (keys.has(key)) {
        if (typeof value === "string") {
          body[key] = replacer(value);
        } else if (Array.isArray(value)) {
          body[key] = value.map((item: unknown) =>
            typeof item === "string" ? replacer(item) : item,
          );
        }
      } else if (isRecord(value)) {
        coder(value);
      } else if (Array.isArray(value)) {
        handleArray(value);
      }
    }
  } else if (Array.isArray(body)) {
    handleArray(body);
  }

  function handleArray(arr: unknown[]) {
    for (const element of arr) {
      if (element != null && typeof element === "object") {
        coder(element);
      }
    }
  }
}

export function outputEncodingReplace(input: string) {
  return input.replaceAll(/<(?=[a-zA-Z/])/g, "\\u003c");
}

export function outputEncodingRestore(input: string) {
  return input.replaceAll(/\\u003c/g, "<");
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return value != null && typeof value === "object" && !Array.isArray(value);
}
